export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/appsumo-original-bg-white.2356d538.svg","height":33,"width":55};